/*
 *
 * ClientsDetail
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 25-Feb-2025
*/

import ClientsDetail from './ClientsDetailContainer'

export default ClientsDetail
